import Vue from 'vue'
import Vuex, { Store } from 'vuex'
import auth from '@/store/modules/auth'
import mission from '@/store/modules/mission'
import layermap from '@/store/modules/layermap'
import ui from '@/store/modules/ui'
import socket from '@/store/modules/socket'
import datapool from '@/store/modules/datapool'
import glider from '@/store/modules/glider'
import enseigne from '@/store/modules/enseigne'
import umbClasse from '@/store/modules/umbClasse'
import umbType from '@/store/modules/umbType'
import user from '@/store/modules/user'
import uniteMobile from '@/store/modules/uniteMobile'
import mesureType from '@/store/modules/mesureType'
import missionGlobal from '@/store/modules/missionGlobal'
import missionVirtual from '@/store/modules/missionVirtual'
import coverageIteration from '@/store/modules/coverageIteration'
import mesureUnite from '@/store/modules/mesureUnite'
import adminMission from '@/store/modules/adminMission'
import debugModule from '@/store/modules/debug'
import fleet from '@/store/modules/fleet'
import role from '@/store/modules/role'
import adminFleet from '@/store/modules/adminFleet'
import missionPlanTemplate from '@/store/modules/missionPlanTemplate'
import positionRemarquable from '@/store/modules/positionRemarquable'
import mapLayer from '@/store/modules/mapLayer'
import types from '@/store/all-mutation-types'
import { IAuthState } from '@/store/modules/auth/state'
import { IDataPoolState } from '@/store/modules/datapool/state'
import { ISocketState } from '@/store/modules/socket/state'
import { IGliderState } from '@/store/modules/glider/state'
import { IEnseigneState } from '@/store/modules/enseigne/state'
import { IUmbClasseState } from '@/store/modules/umbClasse/state'
import { IUmbTypeState } from '@/store/modules/umbType/state'
import { IUserState } from '@/store/modules/user/state'
import { IUniteMobileState } from '@/store/modules/uniteMobile/state'
import { IMesureTypeState } from '@/store/modules/mesureType/state'
import { IMissionGlobalState } from '@/store/modules/missionGlobal/state'
import { IMissionVirtualState } from '@/store/modules/missionVirtual/state'
import { ICoverageIterationState } from '@/store/modules/coverageIteration/state'
import { IMesureUniteState } from '@/store/modules/mesureUnite/state'
import { IAdminMissionState } from '@/store/modules/adminMission/state'
import { IDebugState } from '@/store/modules/debug/state'
import { ILayermapState } from '@/store/modules/layermap/state'
import { IUiState } from '@/store/modules/ui/state'
import { IMissionState } from '@/store/modules/mission/state'
import { IFleetState } from '@/store/modules/fleet/state'
import { IRoleState } from './modules/role/state'
import { IAdminFleetState } from './modules/adminFleet/state'
import { IPositionRemarquableState } from './modules/positionRemarquable/state'
import { IMissionPlanTemplateState } from './modules/missionPlanTemplate/state'
import { IMapLayerState } from './modules/mapLayer/state'
import { toStringDictionary } from '@/utils/groupBy'  
import {debounce} from 'lodash'
import { MISSIONS_DETAIL_TABS } from '@/models/ui/MissionTabs'
import { FLEETS_DETAIL_TABS } from '@/models/ui/FleetTabs'
import { MissionUi } from '@/models/ui/MissionUi'
import { FilterMission } from '@/models/filter/FilterMission'
import { stylesList } from '@/components/map/MapStyles'
import { FleetUi } from '@/models/ui/FleetUi'
import * as d3 from 'd3'  
import { SIMULATIONS_DETAIL_TABS } from '@/models/ui/SimulationTabs'

//installation de vuex
Vue.use(Vuex) 

const debug = process.env.NODE_ENV !== 'production'

/*const initialState = {
  auth: auth.state,
  mission: mission.state,
  glider: glider.state,
  layermap: layermap.state,
  ui: ui.state,
  socket: socket.state,
  datapool: datapool.state
} as IRootState*/

export interface IRootState {
  auth: IAuthState
  mission: IMissionState
  glider: IGliderState
  enseigne: IEnseigneState
  umbClasse: IUmbClasseState
  umbType: IUmbTypeState
  user: IUserState
  layermap: ILayermapState
  ui: IUiState
  socket: ISocketState
  datapool: IDataPoolState
  uniteMobile: IUniteMobileState
  mesureType: IMesureTypeState
  mesureUnite: IMesureUniteState
  adminMission: IAdminMissionState
  debugModule: IDebugState
  fleet: IFleetState
  role: IRoleState
  adminFleet: IAdminFleetState
  missionPlanTemplate:IMissionPlanTemplateState
  positionRemarquable:IPositionRemarquableState
  mapLayer:IMapLayerState
  missionGlobal:IMissionGlobalState
  missionVirtual:IMissionVirtualState
  coverageIteration:ICoverageIterationState
}



const debSaveState = debounce((store:Store<IRootState>) => {    
  const {detailMissions,currentDetailMission,missionsPassedLoaded,missions,filterMission} = store.state.mission
  const {detailFleets,currentDetailFleet,fleets,filterFleet} = store.state.fleet
  const {detailSimulations,currentMissionGlobalId} = store.state.missionGlobal
  localStorage.setItem('savedstate', JSON.stringify({
    usrId:store.state.auth?.userProfile?.id,
    time:new Date().toISOString(),      
       uiState:store.state.ui,
       missionState:{
         detailMissions:detailMissions.map(mu => ({leftPanelWidth:mu.leftPanelWidth,misId:mu.mission.misId,tabsleft:mu.tabsleft,tabsright:mu.tabsright})),
         currentDetailMisId:currentDetailMission.mission?.misId,      
         filterMission   
       },
       simulationState:{
        detailSimulations,
        currentMissionGlobalId,        
       },
       fleetState:{
        detailFleets:detailFleets.map(mu => ({leftPanelWidth:mu.leftPanelWidth,fleId:mu.fleet.FLE_ID,tabsleft:mu.tabsleft,tabsright:mu.tabsright})),
        currentDetailFleId:currentDetailFleet.fleet?.FLE_ID,      
        filterFleet   
      },
      toLoad:{
        missions:missions.filter(m => m._detailLoaded).map(m => ({misId:m.misId,_dataNavigationLoaded:m._dataNavigationLoaded,_dataScienceLoaded:m._dataScienceLoaded,_detailNmeaLoaded:m._detailNmeaLoaded,_driftLoaded:m._driftLoaded,_missionPlanLoaded:m._missionPlanLoaded})),        
        missionsPassedLoaded,
        missionTab:MISSIONS_DETAIL_TABS.map(t => ({cmp:t.cmp,id:t.id})),        
        //fleets:fleets.filter(f => f._detailLoaded).map(f => ({fleId:f.FLE_ID})),
        fleetTab:FLEETS_DETAIL_TABS.map(t => ({cmp:t.cmp,id:t.id})),
        simulationTab:SIMULATIONS_DETAIL_TABS.map(t => ({cmp:t.cmp,id:t.id})),        
      }       
  }))    
},4000)

const SaveStatePlugin = (store:Store<IRootState>) => {
  // called when the store is initialized
  store.subscribe((mutation, state) => {
    // called after every mutation.
    // The mutation comes in the format of `{ type, payload }`.  
    //console.log(mutation.type)
    if(mutation.type.startsWith('UI'))  debSaveState(store)
  })
}

const store = new Vuex.Store<IRootState>({
  modules: {
    auth,
    mission,
    glider,
    enseigne,
    umbClasse,
    umbType,
    user,
    layermap,
    ui,
    socket,
    datapool,
    uniteMobile,
    mesureType,
    mesureUnite,
    adminMission,
    debugModule,
    fleet,
    role,
    adminFleet,
    missionPlanTemplate,
    positionRemarquable,
    mapLayer,
    missionGlobal,
    missionVirtual,
    coverageIteration
  },    
  plugins:[SaveStatePlugin],
  /*mutations: {
    reset (state) {
      Object.keys(state).forEach(key => {
        //@ts-ignore
        Object.assign(state[key], initialState[key])
      })
    }
  },*/
  strict: false
})

export default store


const initialStateCopy = JSON.parse(JSON.stringify(store.state))




export function resetState() {  
  //on reset le state seulement si necessaire
  if (store.state.mission.missions.length > 0) {
    const isConnected = store.myGetters.isConnected    
    //on clear le timeout de la ligne de vie websocket
    if(store.myGetters.keepAliveTimoutId) window.clearTimeout(store.myGetters.keepAliveTimoutId)
    const state = JSON.parse(JSON.stringify(initialStateCopy))        
    //force le reset du token d'authentification car il a pu etre initialisé avec la valeur du local storage
    state.auth.token = ''
    state.socket.isConnected = isConnected
    store.replaceState(state)    
  }
}

export async function loadInitalData() {
  //on est connecté
  if (store.state.mission.missions.length == 0) {   

    //Test si l'on doit restaurer la sauvegarde d'état
    const saveState =  JSON.parse(localStorage?.getItem('savedstate')??'{}')    
    
    if(saveState?.time && store.state.auth.userProfile.id == saveState?.usrId) {
      const now = new Date()
      const diffMilli =  now.getTime() - new Date((Date.parse(saveState.time))).getTime()
      if(diffMilli < (5 * 60 * 1000) && window.confirm("Would you like reload your previous application state?")) {

        //On requete les simulations si besoin
        if(saveState?.simulationState?.currentMissionGlobalId || (saveState?.simulationState?.detailSimulations?.length ?? 0) > 0) {
          const simuToRestaure = [] as Array<Promise<any>>
          simuToRestaure.push(store.dispatch(types.MISSIONGLOBAL_ENSURE_LIST))
          simuToRestaure.push(store.dispatch(types.MISSIONVIRTUAL_ENSURE_LIST))
          simuToRestaure.push(store.dispatch(types.COVERAGEITERATION_ENSURE_LIST))
          await Promise.all(simuToRestaure)
        }

        //On corrige les uiState style
        Object.keys(saveState.uiState.uistates).forEach(uiid => {
          const uiState = saveState.uiState.uistates[uiid]
          if(uiState?.transform)
          {                        
            uiState.transform = d3.zoomIdentity.translate(uiState.transform.x,uiState.transform.y).scale(uiState.transform.k)
          }
          if(uiState?.mapStyles) {
            const style = stylesList.find(s => s.name == uiState.mapStyles.name) 
            if(style) uiState.mapStyles.fct = style.fct
          }          
          if(uiState?.defaultMapStyles) {
            const style = stylesList.find(s => s.name == uiState.defaultMapStyles.name)
            if(style) uiState.defaultMapStyles.fct = style.fct
          }
        })
                
        const missionsToRestaure = [] as Array<Promise<any>>
        missionsToRestaure.push(store.dispatch(types.MISSION_REQUEST,{ongoing:true,yos:true}))
        missionsToRestaure.push(store.dispatch(types.MISSION_REQUEST,{ongoing:false,yos:false}))
        if(saveState?.toLoad?.missionsPassedLoaded?.length > 0) missionsToRestaure.push(store.dispatch(types.MISSION_REQUEST,{ongoing:false,yos:true,gliIds:saveState.toLoad.missionsPassedLoaded}))
        //@ts-ignore
        saveState?.toLoad?.missions?.forEach(m => missionsToRestaure.push(store.dispatch(types.MISSION_ENSURE_MISSION,m.misId)))
                
        

        const lastToRestaure = [] as Array<Promise<any>>
        lastToRestaure.push(store.dispatch(types.ADMINFLEET_ENSURE_LIST))
        // BLF037 — réglages de modules des autres enseignes (flottes et scénarios filtrés par enseigne)
        if (store.getters.isMultiTenantRole) lastToRestaure.push(store.dispatch(types.ENSEIGNE_ENSURE_LIST).catch(() => {}))
        lastToRestaure.push(store.dispatch(types.MAPLAYER_ENSURE_LIST))        
        
        //On requete toute les missions 
        await Promise.all(missionsToRestaure)
        
        //on requete tous les infos détail des mission si besoin 
        //@ts-ignore              
        saveState?.toLoad?.missions?.forEach(m => {
          if(m._dataScienceLoaded) lastToRestaure.push(store.dispatch(types.MISSION_ENSURE_DATA_SCIENCE,m.misId))
          if(m._dataNavigationLoaded) lastToRestaure.push(store.dispatch(types.MISSION_ENSURE_DATA_NAVIGATION,m.misId))
          if(m._driftLoaded) lastToRestaure.push(store.dispatch(types.MISSION_ENSURE_DRIFT,m.misId))
          if(m._missionPlanLoaded) lastToRestaure.push(store.dispatch(types.MISSION_ENSURE_MISSION_PLAN,m.misId))
          Object.keys(m._driftLoaded).forEach(nmea => {
            lastToRestaure.push(store.dispatch(types.MISSION_ENSURE_DATA_NMEA,{typeNmea:nmea,id:m.misId}))
          })
        })

        await Promise.all(lastToRestaure)
              

        //On applique les changements au state
        //store.replaceState()       
        store.state.ui = saveState.uiState

        //restauration missionState        
        //@ts-ignore
        store.state.mission.detailMissions = saveState.missionState.detailMissions.map(mu => new MissionUi({leftPanelWidth:mu.leftPanelWidth,mission:store.getters.missionsById[mu.misId],tabsleft:mu.tabsleft,tabsright:mu.tabsright}))            
        if(saveState.missionState.currentDetailMisId) {
          store.state.mission.currentDetailMission = store.state.mission.detailMissions.find(mu => mu.mission.misId == saveState.missionState.currentDetailMisId)!
        }
        store.state.mission.filterMission = saveState.missionState.filterMission
        //@ts-ignore
        saveState?.toLoad?.missionTab?.forEach(t =>  MISSIONS_DETAIL_TABS.find(tab => tab.cmp == t.cmp)!.id = t.id)

        //restauration fleetState        
        //@ts-ignore
        store.state.fleet.detailFleets = saveState.fleetState.detailFleets.map(fu => new FleetUi({leftPanelWidth:fu.leftPanelWidth,fleet:store.getters.adminFleetsById[fu.FLE_ID],tabsleft:fu.tabsleft,tabsright:fu.tabsright}))            
        if(saveState.fleetState.currentDetailFleId) {
          store.state.fleet.currentDetailFleet = store.state.fleet.detailFleets.find(fu => fu.fleet.FLE_ID == saveState.fleetState.currentDetailFleId)!
        }
        store.state.fleet.filterFleet = saveState.fleetState.filterFleet
        //@ts-ignore
        saveState?.toLoad?.fleetTab?.forEach(t =>  FLEETS_DETAIL_TABS.find(tab => tab.cmp == t.cmp)!.id = t.id)
              
        //restauration simulationState   
        if(saveState?.simulationState?.detailSimulations) store.state.missionGlobal.detailSimulations = saveState.simulationState.detailSimulations
        if(saveState?.simulationState?.currentMissionGlobalId) store.state.missionGlobal.currentMissionGlobalId = saveState.simulationState.currentMissionGlobalId
        //@ts-ignore
        saveState?.toLoad?.simulationTab?.forEach(t =>  SIMULATIONS_DETAIL_TABS.find(tab => tab.cmp == t.cmp)!.id = t.id)

        return
      }
    }
      
    //Si pas de restauration

    //lance la requetes des missions qui se feront avec les bon token d'authorization
    store.dispatch(types.MISSION_REQUEST,{ongoing:true,yos:true}).then(() => {            
      store.dispatch(types.UI_SHOW_ALL_DRAWER_MISSION_MAP,'')
      store.dispatch(types.MISSION_REQUEST,{ongoing:false,yos:false})
    })
    store.dispatch(types.ADMINFLEET_ENSURE_LIST)
    // BLF037 — réglages de modules des autres enseignes (flottes et scénarios filtrés par enseigne)
    if (store.getters.isMultiTenantRole) store.dispatch(types.ENSEIGNE_ENSURE_LIST).catch(() => {})
    //lance la requetes des layersmap
    store.dispatch(types.MAPLAYER_ENSURE_LIST)
    
    /*store.dispatch(types.MESURETYPE_REQUEST).then((data)=>{
      //@ts-ignore
      window.mesureTypesByName = toStringDictionary(store.myGetters.mesureTypes,it=>it.MET_KEY)
    })*/
  }
}
